skrilla.service('sportService', function(searchService){

    const sports = searchService.get('sports').then(function(response){
        return response.data.map(sport => {
            const hubPrefix = sport.hubSlug === "esports" ? "/" : `/${sport.hubSlug}/`;
            const slug = sport.code.toLowerCase();
            return {...sport,
                slug,
                hubPrefix,
                bettingPath: `${hubPrefix}${slug}/betting`
            };
        });
    });

    let getSportsByUser = function (userId) {
        return searchService.get("users/" + userId + "/sports").then(function(response) {
            return response.data
        })
    }

    const getSports = function () {
        return sports;
    };
    const getSport = function (code) {
        return sports.then(it => it.find(it => it.code === code));
    };


    return {
        getSports,
        getSport,
        getSportsByUser
    };
});

